import { Flex } from '@mantine/core';
import { useMove } from '@mantine/hooks';
import { useState } from 'react';
import classes from './table-slider.module.css';
export const TrackContainerContent = () => {
    return (<Flex h='100%' w='100%' gap={4}>
      <Flex direction='column' h='100%' w='100%' gap={2}>
        {Array.from({ length: 4 }).map((_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static content
        <div key={index} className={classes.trackContainerRow}/>))}
      </Flex>
      <Flex direction='column' h='100%' w='100%' gap={2}>
        {Array.from({ length: 4 }).map((_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static content
        <div key={index} className={classes.trackContainerRow}/>))}
      </Flex>
      <Flex direction='column' h='100%' w='100%' gap={2}>
        {Array.from({ length: 4 }).map((_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static content
        <div key={index} className={classes.trackContainerRow}/>))}
      </Flex>
    </Flex>);
};
export const TableSlider = ({ value: valueProp, onChange: onChangeProp }) => {
    const [valueInternal, setValueInternal] = useState(valueProp ?? 0);
    const value = valueProp ?? valueInternal;
    const left = `calc(${value * 100}% - ${value} * var(--thumb-width))`;
    const onChange = (newValue) => {
        setValueInternal(newValue);
        onChangeProp?.(newValue);
    };
    const { ref } = useMove(({ x }) => onChange(x));
    return (<div className={classes.root}>
      <div className={classes.track} ref={ref}>
        <div className={classes.trackContainer}>
          <TrackContainerContent />
        </div>
        <div className={classes.thumb} style={{ left }}/>
      </div>
    </div>);
};
